<div class="wrapper {{type}}">
    <div class="icon">
        <ng-content select="[icon]"></ng-content>
    </div>
    <div class="message-content">
        <ng-content select="[content]"></ng-content>
    </div>
</div>
